import { Box } from '@mui/material'
import colors from 'styles/colors'

const Dot = () => (
  <Box
    sx={{
      width: 5,
      height: 5,
      backgroundColor: colors.Grey250,
      borderRadius: 25
    }}
  />
)

export default Dot
